import React from 'react';
import Calendar from '../../elements/Body/Calendar/Calendar';
class CalendarPage extends React.Component {
  render() {
    return (
      <Calendar />
    );
  }
}
export default CalendarPage;
